const envConfig = {
	STAGE: process.env.REACT_APP_STAGE,
	AUTH_TOKEN: process.env.REACT_APP_AUTH_TOKEN,
	BASE_ENDPOINT: process.env.REACT_APP_BASE_ENDPOINT,
	MAILCHIMP_BASEPOINT: process.env.REACT_APP_MAILCHIMP_BASEPOINT,
	GOOGLE_ANALYTICS_ID: process.env.REACT_APP_GOOGLE_ANALYTICS_ID,
	HJ_ID: process.env.REACT_APP_HJ_ID,
	HJ_V: process.env.REACT_APP_HJ_V,
};

export default envConfig;
